import { useTranslation } from "@coworker/locales";
import FixaButton from "../../../wrappers/FixaButton/FixaButton";
import CrossIconPath from "../../../wrappers/FixaSSRIcon/paths/CrossIconPath";
import ResetFiltersCss from "./ResetFilters.module.css";
import trackerHelper from "@coworker/app/src/helpers/tracker";
import { TrackingProps } from "../../types/component";

interface ResetFiltersProps {
  resetFilters: () => void;
  tracking: TrackingProps;
}
export const ResetFilters = ({ resetFilters, tracking }: ResetFiltersProps) => {
  const { t } = useTranslation();

  return (
    <>
      <FixaButton
        type="secondary"
        ssrIcon={CrossIconPath}
        text={t("resetFiltersString")}
        size="small"
        iconPosition="trailing"
        onClick={() => {
          trackerHelper.filter.trackFilterGeneralClicked(
            tracking.feature,
            tracking.mode,
            "reset_button"
          );
          resetFilters();
        }}
      />
      <div className={ResetFiltersCss["dividerContainer"]}>
        <div className={ResetFiltersCss["divider"]} />
      </div>
    </>
  );
};
